import { getCountries, getCountryCallingCode, type CountryCode } from 'libphonenumber-js'

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' })

export const internationalCountries = getCountries().map((code) => ({
  code,
  name: regionNames.of(code) ?? code,
  callingCode: getCountryCallingCode(code),
}))

export const internationalCountryCodes = new Set<string>(internationalCountries.map((country) => country.code))

export function toCountryCode(code?: string | null): CountryCode | undefined {
  const normalized = code?.toUpperCase()
  return normalized && internationalCountryCodes.has(normalized) ? normalized as CountryCode : undefined
}
